import React, { Component } from 'react'
import './_styles.scss'
import Utils from '../../../../../utils/Utils'
import Asset from '../../../../../requests/apa/Asset'

class FlagSmall extends Component {
  render () {
    const { flagUrl, countryName, iconSize = 'default' } = this.props
    const iconSizeClass = `flag-small__icon-${iconSize}`

    return (
      <div className={`flag-small ${iconSizeClass}`} >
        <div className={`flag-small__image-wrapper`}>
          
          <img
            className='flag-small__image'
            src={flagUrl ? flagUrl : Asset.get('eventodeportivo_carruseletapas_ficha_imagen_placeholder1')}
          />
          
        </div>
        <p className='flag-small__name'>
          {Utils.cutPlayerString( countryName || '', 11)}
        </p>
      </div>
    )
  }
}

export default FlagSmall



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/FlagSmall/index.jsx